import React from "react";
import { Icon, TabControl, TabItem } from "@abb/abb-common-ux-react";

import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";

import InputPosition from "./InputPosition";

import testplanByIdStore from "../../flux/stores/testplan/ByIdStore";

import * as CONSTANTS from "../../utilities/Constants";
import TestplanViewData, {
  defaultTestplanData,
} from "../../models/testplan/TestplanViewData";

import "./testplan.sass";
import { Translation } from "react-i18next";

import "../../utilities/Extensions";
import PositionBar from "./PositionBar";
import KeyedInPartition from "./KeyedInPartition";
import { TestPlanScreen } from "../../utilities/Screen";
import { IKeyedInPartition } from "../../models/testplan/KeyedInPartition";
import MeasuredPartition from "./MeasuredPartition";
import { IInstrumentPartition } from "../../models/testplan/InstrumentPartition";
import NoDataFound from "../shared/NoDataFound";
import History from "../../utilities/History";
import { Input, Dropdown, DropdownOption, LoadingIndicator } from '@abb/abb-common-ux-react';
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  testplanData: TestplanViewData;
  isMeasuredShow: boolean;
  isKeyedInShow: boolean;
  isCalculatedShow: boolean;
  activeTabMeasurement: number;
  activeTabKeyedIn: number;
  activeTabCalculated: number;
}

export default class Landing extends React.Component<{}, ILandingState> {
  private _mount: boolean = false;

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      testplanData: defaultTestplanData,
      isMeasuredShow: true,
      isKeyedInShow: true,
      isCalculatedShow: true,
      activeTabMeasurement: 0,
      activeTabKeyedIn: 0,
      activeTabCalculated: 0
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    testplanByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({ testplanData: state.testplanData });
      }
    });
  }
  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };
  public render() {
    const commonProp = {
      activeTab: this.state.activeTabMeasurement,
      onTabChange: (oldIndex: any, newIndex: any) =>
        this.setState({ activeTabMeasurement: newIndex }),
    };
    const commonProps = {
      activeTab: this.state.activeTabKeyedIn,
      onTabChange: (oldIndex: any, newIndex: any) =>
        this.setState({ activeTabKeyedIn: newIndex }),
    };
    const commonPropCalc = {
      activeTab: this.state.activeTabCalculated,
      onTabChange: (oldIndex: any, newIndex: any) =>
        this.setState({ activeTabCalculated: newIndex }),
    };

    return (
      <Translation>
        {(t) => (
          <div className="page-layout">
            {renderBreadcrumb(
              [
                { text: t("Home"), link: "/samplenew", bolder: false },
                { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                { text: t(CONSTANTS.SUBMENU_TEST_PLAN), link: null, bolder: true }
              ], "pl-3 pb-3")
            }
            <NameHeader
              authKey={CONSTANTS.AUTHKEY_TEST_PLAN}
              data={this.state.testplanData.name}
              isEnable={this.state.testplanData.isEnabled}
              isEnabeDisableButton={true}
            />
            <div className="summary-layout">
              <Summary>
                <div className="page-scroll">
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <span className="summary-label">
                        {" "}
                        {t(CONSTANTS.LABEL_STATE)}:{" "}
                      </span>
                      <span className="summary-value ml-2">
                        {this.state.testplanData.state}
                      </span>
                    </div>

                    <div className="col-md-9" style={{ display: 'flex' }}>
                      <span className="summary-label">
                        {t(CONSTANTS.LABEL_DESCRIPTION)}:
                      </span>
                      <div className="ellipsis-single-line" style={{ lineHeight: '20px' }}>
                        <span className="summary-value ml-2">
                          {this.state.testplanData.description}
                        </span></div>
                    </div>
                  </div>
                </div>
              </Summary>
            </div>
            <div className="mt-3" style={{ background: "#F5F5F5" }}>
              <div>
                <p className="sidebar-main-title font-weight-bold pt-1 ml-3">
                  {t(
                    CONSTANTS.MODULE_TESTPLAN +
                    " " +
                    CONSTANTS.TITLE_TESTOVERVIEW_DETAILS
                  )}
                </p>
              </div>
              <div className="header-underline" />
              <div
                className=" property-text detail-sub-header font-weight-bold mt-2 ml-3"
                onClick={() =>
                  this.setState({
                    isMeasuredShow: !this.state.isMeasuredShow,
                  })
                }
              >
                {this.state.isMeasuredShow ? (
                  <Icon className="mr-3" name="abb/caret-down" />
                ) : (
                  <Icon className="mr-3" name="abb/caret-up" />
                )}
                {t(CONSTANTS.TITLE_MEASUREDPROPERTY)}
              </div>
              <hr className="hr-line mt-2 mx-3" />
              {this.state.isMeasuredShow ? (
                <div className="mt-2 tab-area mx-3">
                  {this.state.testplanData.instruments.length > 0 ? (
                    <div>
                      <TabControl
                        type="primary"
                        {...commonProp}
                        activeTab={this.state.activeTabMeasurement}
                      >
                        {this.state.testplanData.instruments.map(
                          (instrumentDetail: any, index) =>
                            instrumentDetail.isAutoline ? (
                              <TabItem
                                title={instrumentDetail.name}
                                key={index}
                              >
                                <NoDataFound
                                  moduleName={CONSTANTS.MODULE_TESTPLAN}
                                  message={CONSTANTS.AUTOLINE_MESSAGE}
                                />
                              </TabItem>
                            ) : (
                              <TabItem
                                key={index}
                                title={instrumentDetail.name}
                              >
                                <InputPosition
                                  index={index}
                                  isClone={false}
                                  isShowFixed={false}
                                  isStripLength={true}
                                  instrumentState={instrumentDetail}
                                  screenKey={TestPlanScreen.Instrument}
                                />
                                <PositionBar
                                  id={`measuredPositionBar-${index}`}
                                  list={instrumentDetail.partitions}
                                >
                                  {instrumentDetail.partitions.map(
                                    (
                                      item: IInstrumentPartition,
                                      index: number
                                    ) => (
                                      <MeasuredPartition
                                        key={index}
                                        instrument={instrumentDetail}
                                        partition={item}
                                      />
                                    )
                                  )}
                                </PositionBar>
                              </TabItem>
                            )
                        )}
                      </TabControl>
                    </div>
                  ) : (
                    <div>
                      <p className="msg-align">
                        {t(CONSTANTS.TESTPLAN_NO_MEASURED_PROPERTY)}
                      </p>
                    </div>
                  )}
                </div>
              ) : null}
              <div className="header-underline" />
              <div>
                <div
                  className=" property-text detail-sub-header font-weight-bold  mt-2 ml-3"
                  onClick={() =>
                    this.setState({ isKeyedInShow: !this.state.isKeyedInShow })
                  }
                >
                  {this.state.isKeyedInShow ? (
                    <Icon className="mr-3" name="abb/caret-down" />
                  ) : (
                    <Icon className="mr-3" name="abb/caret-up" />
                  )}
                  {t(CONSTANTS.TITLE_KEYEDINPROPERTY)}
                </div>
                <hr className="hr-line mt-2 mx-3" />
                {this.state.isKeyedInShow ? (
                  <div className="mt-2 tab-area mx-3 pb-3">
                    {this.state.testplanData.keyedIns.length > 0 ? (
                      <div>
                        <TabControl
                          type="primary"
                          {...commonProps}
                          activeTab={this.state.activeTabKeyedIn}
                        >
                          {this.state.testplanData.keyedIns.map(
                            (propertyDetail: any, index) => (
                              <TabItem key={index} title={propertyDetail.name}>
                                <InputPosition
                                  screenKey={TestPlanScreen.KeyedInProperty}
                                  keyedInPropertyState={propertyDetail}
                                  index={index}
                                  isClone={false}
                                  isShowFixed={false}
                                  isStripLength={false}
                                />
                                <PositionBar
                                  id={`keyedInPositionBar-${index}`}
                                  list={propertyDetail.partitions}
                                >
                                  {propertyDetail.partitions.map(
                                    (item: IKeyedInPartition, idx: number) => (
                                      <KeyedInPartition
                                        key={idx}
                                        keyedInProperty={propertyDetail}
                                        partition={item}
                                      />
                                    )
                                  )}
                                </PositionBar>
                              </TabItem>
                            )
                          )}
                        </TabControl>
                      </div>
                    ) : (
                      <div>
                        <p className="msg-align">
                          {t(CONSTANTS.TESTPLAN_NO_KEYEDIN_PROPERTY)}
                        </p>
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
              <div className="header-underline" />
              <div
                className=" property-text detail-sub-header font-weight-bold mt-2 ml-3"
                onClick={() =>
                  this.setState({
                    isCalculatedShow: !this.state.isCalculatedShow,
                  })
                }
              >
                {this.state.isCalculatedShow ? (
                  <Icon className="mr-3" name="abb/caret-down" />
                ) : (
                  <Icon className="mr-3" name="abb/caret-up" />
                )}
                {t(CONSTANTS.TITLE_CALCULATEDPROPERTY)}
              </div>
              <hr className="hr-line mt-2 mx-3" />
              {this.state.isCalculatedShow ? (
                <div className="mt-2 tab-area mx-3 pb-3">
                  {this.state.testplanData.calculatedProperties?.length > 0 ? (
                    <div>
                      <TabControl
                        type="primary"
                        {...commonPropCalc}
                        activeTab={this.state.activeTabCalculated}
                      >
                        {this.state.testplanData.calculatedProperties.map(
                          (item: any, index) => (
                            <TabItem key={index} title={item.property.name}>
                              <div className="font-weight-bold mt-1">{t(CONSTANTS.FORMULA_DEFINITION)}</div>
                              <table className="tbl-edit">
                                <thead>
                                  <tr>
                                    <th className="table-title" style={{}}>{t(CONSTANTS.MENU_PROPERTY)}:</th>
                                    <th className="table-title" style={{ paddingLeft: "50px" }}>{t(CONSTANTS.FORMULA)}:</th>
                                  </tr>
                                  <tr>
                                    <td className="mr-1" style={{ background: "none" }}>{item.property.name}</td>
                                    <td className="" style={{ paddingLeft: "45px", background: "none" }}>{item.formulaMappings[0].formula}</td>
                                  </tr>
                                  <tr>
                                    <th className="table-title" style={{}}>{t(CONSTANTS.INPUT_DEFINITION)}:</th>
                                  </tr>
                                  <tr>
                                    <th className="table-title text-uppercase px-3" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_VARIABLE)}</th>
                                    <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_PROPERTYID)}</th>
                                    <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.MENU_PROPERTY)}</th>
                                    <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_PROPERTY_ATTRIBUTE)}</th>
                                    <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_SERIES)}</th>
                                    <th className="table-title text-uppercase" style={{ width: "10%" }}></th>
                                    <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_VALUE)}</th>
                                  </tr>
                                  {item?.formulaMappings[0]?.variableMapping?.map((row:any, i:any) => {
                                    let positionData = "";
                                    let valueData = "";
                                    if(row?.variableMapping?.source?.name === "Position"){
                                      positionData = `Position ${row?.variableMapping?.position + 1}`
                                    } else {
                                      positionData = ""
                                    }
                                    if(row?.variableMapping?.source?.name === "Individual"){
                                      valueData = ""
                                    } else{
                                      valueData = row?.variableMapping?.value?.name
                                    }
                                    return <tr key={i} >
                                      <td>
                                        <Input
                                          disabled={true}
                                          className="disable-color"
                                          dataType="text"
                                          indicateChanged={false}
                                          value={row.variable}
                                        />
                                      </td>
                                      <td>
                                        <Input
                                          disabled={true}
                                          className="disable-color"
                                          dataType="text"
                                          indicateChanged={false}
                                          value={row.property.customId}
                                        />
                                      </td>
                                      <td>
                                        <Input
                                          disabled={true}
                                          className="disable-color"
                                          dataType="text"
                                          indicateChanged={false}
                                          value={row.property.name}
                                        />
                                      </td>
                                      <td>
                                        <Input
                                          disabled={true}
                                          className="disable-color"
                                          dataType="text"
                                          indicateChanged={false}
                                          value={t(row.attribute.name)}
                                        />
                                      </td>
                                      <td>
                                        <Input
                                          disabled={true}
                                          className="disable-color"
                                          dataType="text"
                                          indicateChanged={false}
                                          value={t(row?.variableMapping?.source?.name)}
                                        />
                                      </td>
                                      <td>
                                        <Input
                                          disabled={true}
                                          className="disable-color"
                                          dataType="text"
                                          indicateChanged={false}
                                          value={t(positionData)}
                                        />
                                      </td>
                                      <td>
                                        <Input
                                          disabled={true}
                                          className="disable-color"
                                          dataType="text"
                                          indicateChanged={false}
                                          value={t(valueData)}
                                        />
                                      </td>
                                    </tr>
                                  })}
                                </thead>
                              </table>
                            </TabItem>
                          )
                        )}
                      </TabControl>
                    </div>
                  ) : (
                    <div>
                      <p className="msg-align">
                        {t(CONSTANTS.NO_CALCULATED_PROPERTY)}
                      </p>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
